import { sendAllMessageStrings } from 'constants/strings';

/** LINEのトークに並ぶ吹き出しの共通外枠。 */
const bubbleFrameClass =
  'relative flex-1 rounded-xl border border-neutral-200 bg-transparent';

type TextBubbleProps = {
  text: string;
  /** 本文の下に足すリンク風のボタン。実際にボタンが届く場合だけ渡す。 */
  footerLabel?: string;
};

export function TextBubble({ text, footerLabel }: TextBubbleProps) {
  return (
    <div className={`${bubbleFrameClass} overflow-hidden`}>
      <div className="whitespace-pre-wrap px-3 py-2 text-neutral-600">
        {text}
      </div>
      {footerLabel ? (
        <div className="border-t border-neutral-200 bg-white px-3 py-2 text-center">
          <span className="text-sm font-normal text-blue-500">
            {footerLabel}
          </span>
        </div>
      ) : null}
    </div>
  );
}

type ImageBubbleProps = {
  url: string;
  width?: number | null;
  height?: number | null;
  alt?: string;
};

/**
 * 画像メッセージの吹き出し。
 * タップURLがある場合は画像全体がリンクになるFlexで届くが、見た目は画像のままなので分岐しない。
 */
export function ImageBubble({
  url,
  width,
  height,
  alt = 'Preview',
}: ImageBubbleProps) {
  return (
    <div className={bubbleFrameClass}>
      {/* 読み込み前から縦幅を確保できるよう、判明している実寸を属性でも渡す */}
      <img
        src={url}
        alt={alt}
        width={width ?? undefined}
        height={height ?? undefined}
        className="max-w-full rounded-lg"
      />
    </div>
  );
}

type VideoBubbleProps = {
  url: string;
  poster?: string | null;
  /** タップURLがある場合の表示ラベル。無ければボタンは届かないので出さない。 */
  actionLabel?: string;
};

export function VideoBubble({ url, poster, actionLabel }: VideoBubbleProps) {
  const label = actionLabel?.trim();

  return (
    <div className={bubbleFrameClass}>
      <video
        src={url}
        poster={poster ?? undefined}
        controls
        preload="metadata"
        data-testid="video-bubble"
        className={`max-w-full ${label ? 'rounded-t-lg' : 'rounded-lg'}`}
      />
      {label ? (
        <div className="right-1 flex justify-center px-0">
          <button
            className="text-base px-3 py-1 font-medium text-center whitespace-nowrap max-w-[200px] truncate
             text-accent decoration-accent/60"
            title={label}
          >
            {label}
          </button>
        </div>
      ) : null}
    </div>
  );
}

/** タップURLが設定されているときに、実際に届くボタンの文言を決める。 */
export function mediaActionLabel(
  actionUrl?: string | null,
  actionLabel?: string | null,
): string | undefined {
  if (!actionUrl?.trim()) return undefined;
  return actionLabel?.trim() || sendAllMessageStrings.actionLabelDefault;
}
